import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_ERRORS = 'SET_ERRORS';
export const RESET_ERRORS = 'RESET_ERRORS';

export const setError = makeActionCreator(SET_ERRORS);
export const resetError = makeActionCreator(RESET_ERRORS);
